/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MarketPricing {
    angular.module("meevo.plugins.marketPricing", []);
}